"use client";

import Image from "next/image";

export default function PlacementSkillingSlider({partnerLogo}) {
    // JSON DATA HERE


    // SLICES FOR 3 LINES
    const row1 = partnerLogo.slice(0, 11);
    const row2 = partnerLogo.slice(11, 22);
    // const row3 = partnerLogo.slice(16); 

    return (
        <div className="relative w-full overflow-hidden py-6 md:py-12">
            <div className="page-container">
                <h3 className="font-bold text-[24px] md:text-[30px] lg:text-[36px] text-left" style={{fontFamily:"saans-bold"}}>Campus Placement Drive</h3>
            </div>

            {/* LEFT & RIGHT OVERLAY GRADIENT */}
            <div
                className="hidden sm:block absolute left-0 top-0 h-full w-24 z-20 pointer-events-none"
                style={{ background: "linear-gradient(270deg, rgb(255 255 255 / 5%) 0%, rgb(255 255 255 / 84%) 50%, rgb(255 255 255) 80%)" }}
            />

            <div
                className="hidden sm:block absolute right-0 top-0 h-full w-24 z-20 pointer-events-none"
                style={{ background: "linear-gradient(90deg, rgb(255 255 255 / 0%) 0%, rgb(255 255 255 / 84%) 50%, rgb(255 255 255) 80%)" }}
            />

            {/* ROW 1 */}
            <div className="overflow-hidden py-2">
                <div className="marquee w-max" style={{ "--speed": "80s" }}>
                    {[...row1, ...row1].map((item, i) => <Logo key={i} item={item} />)}
                </div>
            </div>

            {/* ROW 2 */}
            <div className="overflow-hidden py-2">
                <div className="marquee marquee-reverse w-max" style={{ "--speed": "80s" }}>
                    {[...row2, ...row2].map((item, i) => <Logo key={i} item={item} />)}
                </div>
            </div>

            {/* ROW 3 */}
            {/* <div className="overflow-hidden py-2">
                <div className="marquee w-max" style={{ "--speed": "95s" }}>
                    {[...row3, ...row3].map((item, i) => <Logo key={i} item={item} />)}
                </div>
            </div> */}
        </div>
    );
}

// SINGLE LOGO CARD
function Logo({ item }) {
  return (
    <div className="mx-2 flex-shrink-0 flex items-center justify-center 
                    h-[80px] w-[140px] bg-white border-[1px] border-[#0A2131] rounded-lg">
      <Image
        src={item.img}
        alt={item.altText}
        width={120}
        height={60}
        loading="lazy"
        className="object-contain max-h-[60px] max-w-[120px]"
      />
    </div>
  );
}

